import { useState } from "react"
import { AuthContext } from "../../context/AuthContext"
import {
    doc,
    updateDoc,
} from "firebase/firestore"
import { db } from "../../firebase"
import { useListingsContext } from "../../context/ListingsContext";
import Button from 'react-bootstrap/Button';

const ArchiveListing = ({listing, onHide}) => {
    console.log(listing)
    const [acquiredBy, setAcquiredBy] = useState("")

    const listings = useListingsContext().listings
    const updateListings = useListingsContext().updateListings

    const onArchiveClick = async () => {
        await updateDoc(doc(db, "listings", listing.id),{
            active: false,
            acquired_by: acquiredBy
        }).then(res => {
            console.log(res)
            for (const chatroom of listing.chatrooms) {
                updateDoc(
                    doc(db, "chatrooms", chatroom), 
                    { active: false }
                )
            }
            window.location.reload()
        })
    }
    
    return (
        <>
            <p>Who acquired this item?</p>
            <select
                value={acquiredBy}
                onChange={(e)=>{
                    setAcquiredBy(e.target.value)
                }}
            >
                <option value="">Choose here</option>
                {listing.bidders && listing.bidders.map(bidder => <option>{bidder}</option>)}
                <option>Other</option>
                <option>No one</option>
            </select>
            <Button className="btn" 
                onClick={
                    (e) => {
                        if (acquiredBy !== "") {
                            onArchiveClick(e)
                            onHide()
                        }
                        else {
                            alert("Please select an option for who this item was acquired by.")
                        }
                    }
                }
            >Mark as sold</Button>
            <Button className="btn btn-secondary" data-bs-dismiss="modal" 
                onClick={() => {onHide()}}
            >Cancel</Button>
        </>
    )
}

export default ArchiveListing